import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Teleport as _Teleport, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "calculator__grid" }
const _hoisted_2 = {
  key: 0,
  class: "calculator__tell-to-login"
}
const _hoisted_3 = {
  key: 1,
  class: "calculator__save-btn"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 2,
  class: "calculator__save-btn"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "calculator__btn-screen-wrapper tooltip-anchor--no-relative" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Расположить калькулятор сверху экрана", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_calculator_branch = _resolveComponent("calculator-branch")!
  const _component_calculator_save_modal = _resolveComponent("calculator-save-modal")!
  const _component_TooltipComponent = _resolveComponent("TooltipComponent")!
  const _component_IconArrowUp = _resolveComponent("IconArrowUp")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["calculator", { compact: _ctx.$store.state.settings.compactMode }]),
      ref: "calcElem"
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skillsList, (branch, index) => {
          return (_openBlock(), _createBlock(_component_calculator_branch, {
            key: branch,
            skills: _ctx.skillsList[index],
            branchIndex: index,
            remainingStats: _ctx.remainingStats ? _ctx.remainingStats : _ctx.statsPool,
            statsPool: _ctx.statsPool,
            tags: _ctx.tags,
            pointsSpentOnTier1: _ctx.pointsSpentOnTier1,
            soldierClass: _ctx.soldierClass,
            onStatChanged: _ctx.statChanged
          }, null, 8, ["skills", "branchIndex", "remainingStats", "statsPool", "tags", "pointsSpentOnTier1", "soldierClass", "onStatChanged"]))
        }), 128))
      ])
    ], 2),
    (!_ctx.auth)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createTextVNode(" Ты не авторизован. "),
          _createElementVNode("a", {
            href: "#",
            class: "link",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$store.state.modal.isLoginModalVisible = true), ["prevent"]))
          }, "Зарегистрируйся или войди"),
          _createTextVNode(" в аккаунт, чтобы сохранять свои сборки и делиться ими с другими. ")
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isOpenedBySkillBuild)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _withDirectives((_openBlock(), _createElementBlock("button", {
            class: "btn btn-m btn-primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$store.state.modal.isBuildSaveModalVisible = true)),
            disabled: !_ctx.auth,
            id: "saveBuild"
          }, [
            _createTextVNode(" Сохранить сборку ")
          ], 8, _hoisted_4)), [
            [_directive_ripple]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.openedInSingleBuild)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _withDirectives((_openBlock(), _createElementBlock("button", {
            class: "btn btn-m btn-primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$store.state.modal.isBuildSaveModalVisible = true)),
            disabled: !_ctx.auth,
            id: "saveBuild"
          }, [
            _createTextVNode(" Сохранить сборку ")
          ], 8, _hoisted_6)), [
            [_directive_ripple]
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.$store.state.modal.isBuildSaveModalVisible)
        ? (_openBlock(), _createBlock(_component_calculator_save_modal, {
            key: 0,
            onSaveBuild: _ctx.saveBuild,
            soldierClass: _ctx.soldierClass,
            openedInSingleBuild: _ctx.openedInSingleBuild,
            item: _ctx.item,
            onModifyBuild: _ctx.modifyBuild
          }, null, 8, ["onSaveBuild", "soldierClass", "openedInSingleBuild", "item", "onModifyBuild"]))
        : _createCommentVNode("", true)
    ])),
    (_ctx.mounted)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 3,
          to: "#screen-bottom"
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_TooltipComponent, {
              direction: 'left',
              width: 25,
              color: 'dark'
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createElementBlock("button", {
              class: "btn btn-m btn-secondary calculator__btn-screen",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.moveToUpperBoundary && _ctx.moveToUpperBoundary(...args)))
            }, [
              _createVNode(_component_IconBase, null, {
                default: _withCtx(() => [
                  _createVNode(_component_IconArrowUp)
                ]),
                _: 1
              })
            ])), [
              [_directive_ripple]
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}